import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { buildBreadcrumbList } from '../lib/structuredData';
import { ArrowLeftIcon, PaletteIcon, PenToolIcon, LayersIcon, UserIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLidLoisPage: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2643" data-mp="22xc5ma9danev">
      <SEO title="Loïs Bruins, Junior Vormgever | Noord Digital" description="Maak kennis met Loïs Bruins, Junior Vormgever bij Noord Digital. Vertaalt strategie en merk naar visueel werk dat klopt en converteert." canonical="https://noorddigital.nl/over-ons/lois" jsonLd={buildBreadcrumbList([{
      name: 'Over ons',
      path: '/over-ons'
    }, {
      name: 'Loïs Bruins',
      path: '/over-ons/lois'
    }])} data-id="element-2644" data-mp="1y0lorkpqnnse" />
      <Header data-id="element-2645" data-mp="1kafpgq374wf9" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2646" data-mp="1kaz7s7wrdmtt">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2647" data-mp="1p90ownamjc2n">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2648" data-mp="1u728d9bypden">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2649" data-mp="1z3sn9tc162yh" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2650" data-mp="235nz3rrl7yqi">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2651" data-mp="285in9njzaa7v">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] bg-gradient-to-br from-[#EEF5FA] to-[#DCE9F5] flex items-center justify-center shadow-lg overflow-hidden" data-id="element-2652" data-mp="2cxa6te4pvfoi">
                <img src="https://cdn.magicpatterns.com/uploads/o7QWtdg1j2daqsFksK5e45/WhatsApp_Image_2026-06-15_at_17.03.57_-_Copy.jpg" alt="Loïs Bruins" className="w-full h-full object-cover" style={{
                objectPosition: 'center 25%'
              }} data-id="element-2653" data-mp="2mwiwhusju852" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2654" data-mp="10l4wxnvrgurt">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2655" data-mp="10m6aq045vvd8">
                Loïs Bruins
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2656" data-mp="1aj2ke95sqnjd">
                Junior Vormgever
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2657" data-mp="15khnailucjz5">
                <p className="mb-4" data-id="element-2658" data-mp="15mc8zz4xsg4a">
                  Als Junior Vormgever bij Noord Digital maak ik de designs voor
                  onze projecten. Van website-pagina's tot social posts en
                  campagnemateriaal: ik zorg dat het er strak en consistent
                  uitziet.
                </p>
                <p className="mb-4" data-id="element-2659" data-mp="3h9sazfmwfwgf">
                  Ik vertaal de strategie en het merk van een klant naar visueel
                  werk dat klopt. Niet alleen mooi, maar ook duidelijk, zodat de
                  juiste boodschap meteen overkomt en bezoekers weten wat ze
                  moeten doen.
                </p>
                <p data-id="element-2660" data-mp="2xepnpfbuwv50">
                  Ik leer elke dag bij van het team en werk graag mee in
                  iteraties. Feedback is geen kritiek maar materiaal om het
                  ontwerp scherper te maken.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2661" data-mp="2njxlfy7bxk3w">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2662" data-mp="2eh6b61q6wudu">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2663" data-mp="2ej98z7xl3rt4">
                  <PaletteIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2664" data-mp="2ji3qm6jtfabn" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2665" data-mp="cqutefiiizfv">Visueel ontwerp</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2666" data-mp="hnbk9hh3jrwn">
                  <PenToolIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2667" data-mp="2dqpzce1s4397" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2668" data-mp="28sxz8wqzdatx">Branding</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2669" data-mp="23tbjognojihy">
                  <LayersIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2670" data-mp="23vfyvur143xj" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2671" data-mp="1zrqbh8m3bse3">Web design</h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2672" data-mp="1uuzxcqtuj6vb">
                Neem contact op met Loïs
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2673" data-mp="1c25sippxsv4t" />
    </div>;
};